// extracted by mini-css-extract-plugin
export default {"socials":"Socials_socials__OkPjv","divider":"Socials_divider__o64W5","socialsicons":"Socials_socialsicons__kw2Lp"};